import React from "react";

import Wrapper from "./Wrapper";
import Input from "./Input";

const Checkbox = ({ onChange, children, ...props }) => {
  return (
    <Wrapper {...props}>
      <Input type="checkbox" checked={props.checked} onChange={onChange} />
      {children}
    </Wrapper>
  );
};

export default Checkbox;
